import React, { Suspense } from 'react';
import {
    Routes,
    Route,
    Navigate,
    useLocation
} from 'react-router-dom';
import { useAppSelector } from 'hooks/useStore';
import { DISABLE_TEST_REPORT } from 'global/constants';

import Loader from 'components/Loader';
import SAT from 'pages/public/Tests/SAT';
import PSAT from 'pages/public/Tests/PSAT';
import ACT from 'pages/public/Tests/ACT';
import Profile from 'pages/private/Profile';
import DigitalSAT from 'pages/private/DigitalSAT';
import DigitalACT from 'pages/private/DigitalACT';
import DigitalSATReport from 'pages/private/DigitalSAT/DigitalSATReport';
import DigitalSATReview from 'pages/private/DigitalSAT/DigitalSATReview';
import DigitalACTReport from 'pages/private/DigitalACT/DigitalACTReport';
import DigitalACTReview from 'pages/private/DigitalACT/DigitalACTReview';
import NotFound from 'pages/error/NotFound';
import Unauthorized from 'pages/error/Unauthorized';
import ServerError from 'pages/error/ServerError';

function PrivateRoutes() {
    const { status } = useAppSelector(state => state.error);
    const { organization } = useAppSelector(state => state.organization);

    const { state } = useLocation() as {
        state?: { referrer?: string; }
    };

    if (status === 401) return <Unauthorized />;
    else if (status !== null) return <ServerError />;

    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                <Route path='/' element={<Navigate to='/tests/digital-sat' />} />
                <Route path='/account' element={<Profile />} />
                <Route path='/tests/digital-sat' element={<SAT />} />
                <Route path='/tests/digital-psat' element={<PSAT />} />
                <Route path='/tests/digital-act' element={<ACT />} />
                <Route path='/digital/sat/:testId' element={<DigitalSAT />} />
                <Route path='/digital/act/:testId' element={<DigitalACT />} />
                {!DISABLE_TEST_REPORT.includes(organization.alias) && <>
                    <Route path='/report/digital-sat/:testId' element={<DigitalSATReport />} />
                    <Route path='/review/digital-sat/:testId' element={<DigitalSATReview />} />
                    <Route path='/report/digital-act/:testId' element={<DigitalACTReport />} />
                    <Route path='/review/digital-act/:testId' element={<DigitalACTReview />} />
                </>}
                <Route path='/sign-in' element={<Navigate to={state?.referrer
                    ? state.referrer
                    : '/'
                } replace />} />
                <Route path='*' element={<NotFound />} />
            </Routes>
        </Suspense>
    );
}

export default PrivateRoutes;